module.exports = __webpack_public_path__ + "static/media/badge_shuxue.6fda0d5d.png";